import React, { useState } from "react";
import BannerBreadcrumb from "../../Components/BannerBreadcrumb";
import LocationPinIcon from '@mui/icons-material/LocationPin';

const ProdigyFinanceLendingPartner = () => {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        message: "",
        type: "Landing Partner"
    });
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(null);
    const [fieldErrors, setFieldErrors] = useState({});
    const validate = () => {
        const errors = {};
        if (!formData.name.trim() || !/^[a-zA-Z\s]+$/.test(formData.name)) {
            errors.name = "Name should contain only letters and spaces.";
        }
        if (!/^\d{10}$/.test(formData.phone)) {
            errors.phone = "Phone number must be exactly 10 digits.";
        }
        if (!formData.email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
            errors.email = "Please enter a valid email address.";
        }
        if (!formData.message || !formData.message.trim()) {
            errors.message = "Message is required.";
        }
        return errors;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "phone") {
            if (!/^\d*$/.test(value)) return;
        }
        if (name === "name") {
            if (!/^[a-zA-Z\s]*$/.test(value)) return;
        }
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
        setFieldErrors((prev) => ({
            ...prev,
            [name]: undefined
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSuccess(false);
        setError(null);

        const errors = validate();
        setFieldErrors(errors);
        if (Object.keys(errors).length > 0) {
            setLoading(false);
            return;
        }

        setLoading(true);

        try {
            const formBody = new URLSearchParams(formData).toString();
            await fetch("https://script.google.com/macros/s/AKfycbytFPsSA7Ob7jAQVmRXGHReCfkcWZmnCvpOLdSL7Zw3kEIvSn5YoQELdQBZOLJccA0/exec", {
                method: "POST",
                body: formBody,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
            });
            setSuccess(true);
            setFormData({
                name: "",
                email: "",
                phone: "",
                message: "",
                type: "Landing Partner"
            });
        } catch (err) {
            setError("Failed to submit. Please try again.");
        }

        setLoading(false);
    };
    const uniqueFeatures = [
        {
            title: "1. Can Prodigy help with covering living expenses?",
            content: "Yes, living expenses and tuition are covered by Prodigy Finance."
        },
        {
            title: "2. What does APR stand for?",
            content: "The APR, also known as the Annual Percentage Rate, is a percentage that shows the total cost of borrowing money over a year. It includes all the fees and extra expenses related to the loan."
        },
        {
            title: "3. Does Prodigy Finance charge a fee for early repayment on education loans?",
            content: "There are no charges for prepaying the Prodigy Finance education loan."
        },
        {
            title: "4. What is the annual percentage rate (APR) for the Prodigy Finance loan for studying abroad?",
            content: "Prodigy Finance charges an average APR rate of 14.96% for their education loans for studying abroad"
        }, {
            title: "5. Can you provide information about the interest rate for Prodigy Finance education loans?",
            content: "Prodigy Finance provides rates of interest that vary from 11.5% to 13.5%."
        }, {
            title: "6. Is there any margin money needed for a loan from Prodigy Finance?",
            content: "Margin money is not necessary for loans from Prodigy Finance"
        },
        {
            title: "7. How long is the repayment period for an education loan from Prodigy for studying abroad?",
            content: "The maximum repayment tenure for an education loan from Prodigy is 15 years."
        }, {
            title: "8. What is the address of the Prodigy Finance India office?",
            content: "Whether you are in Hyderabad or Vijayawada, you have the option to reach out to Prodigy Finance by emailing them at info@prodigyfinance.com. Alternatively, you can make things even easier for yourself by allowing Credere to take care of everything and guide you through the entire process."
        }
    ];

    const [openIndex, setOpenIndex] = useState(null);
    const handleAccordion = idx => {
        setOpenIndex(openIndex === idx ? null : idx);
    };
    return (
        <>
            <BannerBreadcrumb head={"Prodigy Education Loan"} parades={"Get Free Education Loan Assistance From Credere"} pagename={"Prodigy Education Loan"} />
            <section className="blog-section">
                <div className="container">
                    <div className="row">
                        <div className="col-md-8 loan-eligibility">
                            <h5 className="about-head">Prodigy Finance Education Loan for Abroad Studies</h5>
                            <p className="loan-elegibility-des">Credere is aware of how challenging it might be to get an education loan for overseas study. Particularly for individuals without any collateral or co-applicant to assist application. Credere has teamed up with Prodigy Finance to assist these students in achieving the goals they have set.
                                <br /><br />
                                With its establishment in 2007, Prodigy Finance has brought about an amazing revolution in the education loan process. This UK-based financial institution has prioritized delivering top-notch service while revolutionizing the way scholars access funding for their education. The idea behind Prodigy Finance is that money shouldn’t be a barrier to education. For the past 16 years, they have assisted students in obtaining study abroad education loans without the need for collateral or co-applicants based on their academic records.
                                <br /><br />
                                When it comes to connecting with Prodigy Finance and becoming part of the community of international students they support, Credere is the right place to get in touch with.</p>


                            <h5 className="about-head">Overview of Prodigy Finance Education Loan</h5>
                            <p className="loan-elegibility-des">More than 1051 institutions, primarily in the USA and Canada, are eligible for Prodigy Financing education loans, which are distributed throughout 19 different countries.
                                <br /><br />
                                Some of the advantages that are accessible to you if you opt to apply for a Prodigy Finance loan are shown in the table below.</p>
                            <table className="table table-bordered table-striped customtable mt-4 mb-4">
                                <thead className="table-head">
                                    <tr>
                                        <th>Features</th>
                                        <th>Description	</th>


                                    </tr>

                                </thead>
                                <tbody className="table-body">
                                    <tr>
                                        <td className="">
                                            Rate of interest</td>
                                        <td className="">

                                            11.5%-13.5%
                                        </td>


                                    </tr>
                                    <tr>
                                        <td className="">
                                            Loan amount</td>
                                        <td className="">
                                            Up to 100% cost to study

                                        </td>


                                    </tr>
                                    <tr>
                                        <td className="">
                                            Interest Rate Type</td>
                                        <td className="">

                                            Floating

                                        </td>


                                    </tr>
                                    <tr>
                                        <td className="">
                                            Minimum Income
                                        </td>

                                        <td className="">
                                            Not Required</td>

                                    </tr>
                                    <tr>
                                        <td className="">

                                            Repayment
                                        </td>
                                        <td className="">

                                            In Prodigy, Nothing is to be paid during the course duration + 6 months. The 1st payment that needs to be done is an EMI Payment after course duration + 6 months.
                                        </td>


                                    </tr>

                                    <tr>
                                        <td>
                                            Minimum Income</td>
                                        <td>N/A</td></tr>
                                    <tr>
                                        <td>Repayment</td>
                                        <td>Simple Interest during the course and also during 6 Month grace period</td>
                                    </tr>
                                    <tr>
                                        <td>Processing Fees</td>
                                        <td>Upto 5% added to loan amount</td>
                                    </tr>
                                    <tr>
                                        <td>Other Charges</td>
                                        <td>N/A</td>
                                    </tr>
                                    <tr>
                                        <td>Margin Money</td>
                                        <td>0</td>
                                    </tr>
                                    <tr>
                                        <td>Loan Tenure</td>
                                        <td>Upto 15 years</td>
                                    </tr>
                                    <tr>
                                        <td>Processing</td>
                                        <td>Upto 7 years</td>
                                    </tr>
                                </tbody>
                            </table>


                        </div>
                        <div className="col-md-4">
                            <div className="blog-right">
                                <form className="loan-check-form" style={{ padding: "50px" }} onSubmit={handleSubmit}>
                                    <h4 className="" style={{ fontSize: "20px" }}>Contact Now</h4>
                                    {success && <div className="alert alert-success mt-2">Submitted successfully!</div>}
                                    {error && <div className="alert alert-danger mt-2">{error}</div>}
                                    <div className="row">
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Name <span>*</span></label>
                                            <input
                                                type="text"
                                                className="form-control finance-input"
                                                placeholder="E.g. Priya Senger"
                                                name="name"
                                                value={formData.name}
                                                onChange={handleChange}
                                                required
                                            />
                                            {fieldErrors.name && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.name}</div>
                                            )}
                                        </div>
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Email <span>*</span></label>
                                            <input
                                                type="email"
                                                className="form-control finance-input"
                                                placeholder="E.g. priya@doe.com"
                                                name="email"
                                                value={formData.email}
                                                onChange={handleChange}
                                                required
                                            />
                                            {fieldErrors.email && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.email}</div>
                                            )}
                                        </div>
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Phone<span>*</span></label>
                                            <input
                                                type="tel"
                                                className="form-control finance-input"
                                                placeholder="E.g. 8888880000"
                                                name="phone"
                                                value={formData.phone}
                                                onChange={handleChange}
                                                required
                                                maxLength={10}
                                            />
                                            {fieldErrors.phone && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.phone}</div>
                                            )}
                                        </div>
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Message<span>*</span></label>
                                            <textarea
                                                type="text"
                                                className="form-control finance-input"
                                                placeholder="Your message"
                                                name="message"
                                                value={formData.message}
                                                onChange={handleChange}
                                                required
                                            />
                                            {fieldErrors.message && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.message}</div>
                                            )}
                                        </div>
                                        <div className="col-12">
                                            <button type="submit" className="loan-btn w-100 mt-3" disabled={loading}>
                                                {loading ? "Submitting..." : "Submit"}
                                            </button>
                                        </div>
                                    </div>
                                </form>

                                <section className="landing-partners mt-5" >
                                    <div className="container">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <h5 className="about-head mb-5 text-center">Our Loan Partners</h5>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/icici-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/auxilo-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/avanse-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/axis-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/bob-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/hdfc-credila-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/union-bank-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/idfc-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/increc-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/mpower-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/prodigy-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/sbi-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>
                        <div className="col-md-12 loan-eligibility">

                            <h5 className="about-head">Requirements for Prodigy Finance education loan eligibility</h5>

                            <ol className="subhead-ul">
                                <li>Prodigy Finance only offers loans for Master’s programs, so you need to consider pursuing a Master’s degree if you want to apply for their loans.</li>
                                <li>Make sure you are prepared to study in a different country.</li>
                                <li>To be eligible for an education loan, you need to live in a country that is supported under the Prodigy Finance education loan. </li>
                                <li>To be eligible for Prodigy Finance education loans, your University or College and desired course of study must be on the approved list.</li>
                            </ol>
                            <h5 className="about-head">Documents required for Prodigy Finance Education Loan</h5>



                            <ol className="subhead-ul">
                                <li>Taking out a Prodigy Finance education loan doesn’t involve a long list of requirements. The documents needed to apply for a loan for studying abroad with Prodigy Finance are quite simple.</li>
                                <li>Proof of Address: This document must show your name and residential address, which should match the information provided in your application.</li>
                                <li>Proof of Identity: This is a copy of your valid passport in a readable format.</li>
                                <li>Your letter of acceptance to the school, so Prodigy can verify the course and university.</li>
                                <li>A credit report is also needed.</li>
                            </ol>


                            <h5 className="about-head">Which courses are eligible for an education loan from Prodigy Finance?</h5>
                            <p className="loan-elegibility-des">The courses listed below are eligible for the education loan from Prodigy Finance:</p>
                            <ol className="subhead-ul">
                                <li>STEM (Science, Technology, Engineering, Mathematics)</li>
                                <li>Public Policy</li>
                                <li>Business</li>
                                <li>Law</li>
                                <li>Economics</li>
                                <li>Health Sciences</li>
                            </ol>
                            <h5 className="about-head">Steps to apply for Prodigy Finance education loan via Credere</h5>
                            <p className="loan-elegibility-des">
                                You may apply online at Prodigy Finance’s website to be eligible for an education loan. However, applying for your education loan with Credere offers a hassle-free experience.
                                <br /><br />
                                Credere is a digital platform that aims to aid Indian students in financing their studies overseas. It works with various lenders, including Prodigy Finance. To begin, all you have to do is check your loan eligibility and we will handle the rest for you! </p>
                            <h5 className="about-head">Reasons to Choose Credere for your Prodigy Finance Education Loan</h5>



                            <p className="loan-elegibility-des"><b>Best Loan Assured</b></p>
                            <p className="loan-elegibility-des">Credere strives to offer its clients the greatest student loan option in the market. Credere will cover the difference in interest rates if you discover a superior option.</p>
                            <p className="loan-elegibility-des"><b>Entirely Online Process</b></p>
                            <p className="loan-elegibility-des">The entire Prodigy Finance education loan process is conducted online, eliminating the need for borrowers to physically visit the company.</p>
                            <p className="loan-elegibility-des"><b>Quick Processing Time</b></p>
                            <p className="loan-elegibility-des">After all necessary paperwork for your Prodigy Finance education loan has been filed, your loan will be approved within seven days. </p>
                            <p className="loan-elegibility-des"><b>Assistance from Credere</b></p>
                            <p className="loan-elegibility-des">Credere will offer free assistance throughout the Prodigy Finance education loan application procedure.
                                <br /><br />
                                Kindly be aware that once your loan is approved, Prodigy Finance will require a prepaid fee of 50 USD. Only after this fee has been paid by the student, a sanction letter will be provided.
                                <br /><br />
                                An applicant will have to pay the pre-paid costs again for their new application if they want to withdraw and reapply to a different institution. The student will get an exact refund of the application money they had paid for the prior application.</p>
                            <h5 className="about-head">Ways to get in touch with Prodigy Finance</h5>
                            <p className="loan-elegibility-des">You may get in touch with Prodigy Finance in several ways, including –</p>
                            <p className="loan-elegibility-des"><b>Sending an email to Prodigy Finance</b></p>
                            <p className="loan-elegibility-des">Email ID: info@prodigyfinance.com
                                <br />
                                You can contact Prodigy Finance at the email address listed above if you have queries or require any kind of support.</p>


                            <p className="loan-elegibility-des"><b>Filling out the Online Contact Form</b></p>
                            <p className="loan-elegibility-des">Visit – <a href="https://www.support.prodigyfinance.com/hc/en-us/requests/new" style={{ textDecoration: "none", color: "var(--primarycolor" }}> www.support.prodigyfinance.com/hc/en-us/requests/new</a>
                                <br />
                                On their official website, there is an online contact form that you may fill out with a few essential details. After you provide all of these details, Prodigy Finance’s customer support team receives them and gets in touch with you.</p>
                            <p className="loan-elegibility-des"><b>Office visit</b></p>
                            <p className="loan-elegibility-des">Address: 16-18 Beak St, Carnaby, United Kingdom (Headquarters)
                                <br /><br />
                                Although they don’t have their own office in India, they may outsource their business to a third party.
                                <br /><br />
                                When submitting a loan application, you are not required to get in contact with Prodigy Finance personally. You may apply for a loan online and complete the procedure at your convenience, as it is completely online. Furthermore, if you choose to cooperate with Credere, their Loan Counsellor will act as your mentor and take care of all communications with Prodigy Finance. This implies that getting an education loan for an overseas study becomes effortless because Credere manages everything for you. This simplified procedure enables rapid access to the required funds, providing you with convenience and assurance.</p>
                            <h5 className="about-head mt-4"> FAQ (Frequently Asked Questions) </h5>


                            {uniqueFeatures.map((item, idx) => (
                                <div className={`accordion-item${openIndex === idx ? ' open' : ''}`} key={idx}>
                                    <button className="accordion-title" onClick={() => handleAccordion(idx)}>
                                        {item.title}
                                        <span className="accordion-arrow">{openIndex === idx ? '-' : '+'}</span>
                                    </button>
                                    <div className="accordion-content" style={{ maxHeight: openIndex === idx ? '500px' : '0' }}>
                                        <p className="loan-eligibility-des mb-0">{item.content}</p>
                                        <p className="loan-eligibility-des mt-3"><b>{item.head}</b>{item.content1}</p>
                                        <p className="loan-eligibility-des"><b>{item.head1}</b>{item.content2}</p>
                                    </div>
                                </div>

                            ))}
                        </div>
                    </div>
                </div>
            </section >
        </>
    )
}

export default ProdigyFinanceLendingPartner;